var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCss3Wordmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "undefined",
    height: "undefined",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#131313",
    d: "M89.234 5.856H81.85l7.679 8.333v3.967H73.713v-4.645h7.678l-7.678-8.333V1.207h15.521v4.649zm-18.657 0h-7.384l7.679 8.333v3.967H55.055v-4.645h7.679l-7.679-8.333V1.207h15.522v4.649zm-18.474.19h-7.968v7.271h7.968v4.839H38.471V1.207h13.632v4.839z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1572B6",
    d: "m27.613 116.706l-8.097-90.813h88.967l-8.104 90.798l-36.434 10.102l-36.332-10.087z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#33A9DC",
    d: "m64.001 119.072l29.439-8.162l6.926-77.591H64.001v85.753z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64 66.22h14.738l1.019-11.405H64V43.677h27.929l-.267 2.988l-2.737 30.692H64V66.22z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "m64.067 95.146l-.049.014l-12.404-3.35l-.794-8.883H39.641l1.561 17.488l22.814 6.333l.052-.015V95.146z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.792 76.886L76.45 91.802l-12.422 3.353v11.588l22.833-6.328l.168-1.882l1.938-21.647H77.792z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M64.039 43.677v11.137H37.136l-.224-2.503l-.507-5.646l-.267-2.988h27.901zM64 66.221v11.138H51.753l-.223-2.503l-.508-5.647l-.267-2.988H64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3Wordmark);
export default __webpack_public_path__ + "static/media/css3-wordmark.4c87da93859a8ce5b390537d0db4c4ca.svg";
export { ForwardRef as ReactComponent };